export default (state, parent_id) => {
  const { fullListOfMeasures } = state;
  return fullListOfMeasures.filter((n) => n.ps_id === parent_id);
};
